// extracted by mini-css-extract-plugin
export var alignCenter = "QuickPreferences-module--alignCenter--951e1";
export var button = "QuickPreferences-module--button--c3985";
export var flex = "QuickPreferences-module--flex--1be52";
export var optionIcon = "QuickPreferences-module--optionIcon--63ee5";
export var optionLabel = "QuickPreferences-module--optionLabel--51012";
export var radio = "QuickPreferences-module--radio--6b11b";
export var savedButton = "QuickPreferences-module--savedButton--19002";